<template>
  <ListInvoices />
</template>

<script>
import ListInvoices from '@/views/invoice/components/ListInvoices'

export default {
  name: 'Home',
  components: { ListInvoices },
}
</script>

<style lang="css" scoped>
:focus {
  outline: -webkit-focus-ring-color none !important;
}
</style>
